import ApplicationDetails from './Step1';
import LinksAndTags from './Step2';
import ConfigureHomepage from './Step3';
import HelpPanelConfiguration from './Step4';

export const AdminNewAppWizardSteps: any[] = [
  {
    title: 'Application Details',
    description: '',
    stateKey: 'applicationDetails',
    StepContent: ApplicationDetails,
    isOptional: false
  },
  {
    title: 'Links and Tags',
    description: '',
    stateKey: 'linksAndTags',
    StepContent: LinksAndTags,
    isOptional: true
  },
  {
    title: 'App Widgets',
    description: '',
    stateKey: 'homePageConfigurations',
    StepContent: ConfigureHomepage,
    isOptional: true
  },
  {
    title: 'Side Panel Details',
    description: '',
    stateKey: 'helpPanelConfiguration',
    StepContent: HelpPanelConfiguration,
    isOptional: true
  }
];
